<app-data-box [headerTitle]="getStationTitle()" class="mt-32">
  <div class="data-box-content">
    <div *ngIf="airportWeather?.station?.type === 'dep' || airportWeather?.station?.type === 'to_alt'"
      class="text-center thin-gray-border zulu-time text-sm">
      <span class="label-3">Depart </span>
      <span class="font-bold">{{ departureTime?.toFormat('HH:mm') }}</span>
      <span class="opacity-6"> (Z) {{ departureTime?.toFormat('LLL dd') }}</span>
    </div>
    <div *ngIf="airportWeather?.station?.type === 'arr' || airportWeather?.station?.type === 'alt'"
      class="text-center thin-gray-border zulu-time text-sm">
      <span class="label-3">Arrive </span>
      <span class="font-bold">{{ arrivalTime?.toFormat('HH:mm') }}</span>
      <span class="opacity-6"> (Z) {{ arrivalTime?.toFormat('LLL dd') }}</span>
    </div>
    <div class="text-sm accent-color font-medium">METAR</div>
    <pre *ngFor="let line of airportWeather?.metar?.lines" class="text-base">{{ line.text }}</pre>
    <div class="text-sm accent-color mt-16 font-medium">TAF</div>
    <pre *ngFor="let line of airportWeather?.taf?.lines" [class.highlight]="line.classes"
      [class.indented]="!line.text.startsWith('TAF')" class="text-base weather-card">{{ line.text }}</pre>
  </div>
</app-data-box>